import React from "react";
import { createRoot, type Root } from "react-dom/client";
import App from "./App";
import "./index.css";
import { Toaster } from "react-hot-toast";

const rootElement = document.getElementById("root");
document.documentElement.setAttribute("data-theme", "black");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

// 1. Tell TypeScript that our window object might have a React root cached
declare global {
  interface Window {
    __REACT_ROOT__?: Root;
  }
}

// 2. Only create a new root if one does NOT exist on the window
if (!window.__REACT_ROOT__) {
  window.__REACT_ROOT__ = createRoot(rootElement);
}

// 3. Render the app using the cached root (this handles HMR updates smoothly)
window.__REACT_ROOT__.render(
  <React.StrictMode>
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: "#1d232a",
          color: "#a6adba",
          border: "1px solid #2a323c",
          borderRadius: "0.75rem",
          padding: "0.875rem 1rem",
          fontSize: "0.875rem",
          fontWeight: "500",
          boxShadow:
            "0 10px 15px -3px rgba(0,0,0,0.4), 0 4px 6px -4px rgba(0,0,0,0.4)",
        },
        success: {
          iconTheme: {
            primary: "#00d26a",
            secondary: "#1d232a",
          },
        },
        error: {
          iconTheme: {
            primary: "#ff6b6b",
            secondary: "#1d232a",
          },
        },
      }}
    />
    <App />
  </React.StrictMode>,
);
